import PropTypes from 'prop-types'
import NoContentHistoricIcon from './no_content.svg'
import { StyledContainer, StyledEmptyMessageContainer, StyledEmptyIcon, StyledEmptyText } from './styled-components'
import ModuleToggle from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleToggle'
import ModuleHeading from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeading'
import IconCarbonRotate360 from '@/shared/icons/IconCarbonRotate360'
import ModuleHeader from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeader'
import { ModuleContent } from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'

const HistoricSalesEmpty = ({ t, expanded, toggle }) => (
  <StyledContainer>
    <ModuleHeader clickable onClick={toggle}>
      <ModuleHeading icon={IconCarbonRotate360} moduleKey='historic-sales'>
        {t('subscriptionTools:historic_contracts.module_title')}
      </ModuleHeading>
      <ModuleToggle expanded={expanded} onToggle={toggle} moduleKey='historic-sales' />
    </ModuleHeader>
    <ModuleContent hidden={!expanded}>
      <StyledEmptyMessageContainer>
        <StyledEmptyIcon src={NoContentHistoricIcon} alt='No historic content' />
        <StyledEmptyText>{t('subscriptionTools:historic_contracts.empty_text')}</StyledEmptyText>
      </StyledEmptyMessageContainer>
    </ModuleContent>
  </StyledContainer>
)

HistoricSalesEmpty.propTypes = {
  t: PropTypes.func,
  expanded: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default HistoricSalesEmpty
